import { cva } from "class-variance-authority";

export const tourSurfaceVariants = cva("", {
  variants: {
    surface: {
      highlight:
        "bg-gradient-to-br from-background-alt via-[var(--metric-card-gradient-via)] to-[var(--metric-card-gradient-to)]",
    },
  },
  defaultVariants: { surface: "highlight" },
});
